import React from 'react';
import { usePageBanners } from '../../../hooks/usePageBanners';
import PageBanner from '../PageBanner/PageBanner';
import './ContactHero.css';

const SECTION = 'Contact Us';

const ContactHero = () => {
  const { hasDynamicBanner, banners } = usePageBanners(SECTION);

  return (
    <section className="contact-hero">
      {hasDynamicBanner && <PageBanner banners={banners} />}
      {!hasDynamicBanner && (
        <div className="contact-hero-title-section contact-hero-title-section--standalone">
          <div className="container">
            <div className="contact-hero-content">
              <h1 className="contact-title">
                Contact Us
              </h1>
              <p className="contact-subtitle">
                We'd love to hear from you
              </p>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default ContactHero;
